/**
 * Mirrors the legacy `SWReactTableWrapper` pagination event label so existing analytics
 * keep matching: adjacent moves are labelled with the (1-based) page being left, and
 * longer jumps with the full `from-to` range.
 */
export const getPaginationTrackingLabel = (fromPage: number, toPage: number): string => {
    const isAdjacent = Math.abs(toPage - fromPage) === 1;
    const direction = isAdjacent ? (toPage > fromPage ? "next" : "prev") : "manual";
    const value = isAdjacent ? fromPage : `${fromPage}-${toPage}`;
    return `Table/${direction}/${value}`;
};
